import { css } from '@emotion/react';

export default css`
  p:last-child {
    margin: 0 !important;
  }
`;
